import type { MatriculaEscola, MatriculaTurnos, NivelEnsinoR065 } from '../types/database'

const PREFIX: Record<NivelEnsinoR065, string> = {
  infantil: 'infantil',
  fund_menor: 'fund_menor',
  fund_maior: 'fund_maior',
  eja: 'eja',
}

export function turnosFromMatricula(m: MatriculaEscola, nivel: NivelEnsinoR065): MatriculaTurnos {
  const p = PREFIX[nivel]
  const turnos = {
    m: Number(m[`${p}_m` as keyof MatriculaEscola]) || 0,
    t: Number(m[`${p}_t` as keyof MatriculaEscola]) || 0,
    n: Number(m[`${p}_n` as keyof MatriculaEscola]) || 0,
    i: Number(m[`${p}_i` as keyof MatriculaEscola]) || 0,
    total: 0,
  }
  turnos.total = turnos.m + turnos.t + turnos.n + turnos.i
  return turnos
}

export function sumTurnos(t: Pick<MatriculaTurnos, 'm' | 't' | 'n' | 'i'>): number {
  return (t.m || 0) + (t.t || 0) + (t.n || 0) + (t.i || 0)
}

export function formatTurnosResumo(t: MatriculaTurnos) {
  const parts = [
    t.m ? `M:${t.m}` : '',
    t.t ? `T:${t.t}` : '',
    t.n ? `N:${t.n}` : '',
    t.i ? `I:${t.i}` : '',
  ].filter(Boolean)
  const total = sumTurnos(t)
  return parts.length ? `${parts.join(' ')} (Σ${total})` : '—'
}

export const TURNOS_COLUNAS = ['M', 'T', 'N', 'I', 'Total'] as const
export const TURNOS_MTNI = ['M', 'T', 'N', 'I'] as const

export function temDadosTurnos(t: MatriculaTurnos | null | undefined) {
  if (!t) return false
  return t.m > 0 || t.t > 0 || t.n > 0 || t.i > 0 || t.total > 0
}

export function celulaMatricula(valor: number, temMatricula: boolean) {
  if (!temMatricula) return ''
  return String(valor)
}

export function turnosTotaisEscola(m: MatriculaEscola): MatriculaTurnos {
  const niveis: NivelEnsinoR065[] = ['infantil', 'fund_menor', 'fund_maior', 'eja']
  const acc = { m: 0, t: 0, n: 0, i: 0, total: 0 }
  for (const nivel of niveis) {
    const t = turnosFromMatricula(m, nivel)
    acc.m += t.m
    acc.t += t.t
    acc.n += t.n
    acc.i += t.i
  }
  acc.total = acc.m + acc.t + acc.n + acc.i
  return acc
}

export function nivelTemDados(rows: { matricula?: MatriculaEscola | null }[], nivel: NivelEnsinoR065) {
  return rows.some((e) => e.matricula && temDadosTurnos(turnosFromMatricula(e.matricula, nivel)))
}

export function escolaTemTotal(rows: { matricula?: MatriculaEscola | null; total_alunos?: number }[]) {
  return rows.some((e) => (e.matricula?.total_escola ?? e.total_alunos ?? 0) > 0)
}
